import React, { Component } from "react";
import moment from "moment";

import ParadigmaTable from "../../../components/ParadigmaTable";
import api from "../../../api/api";
import { format } from "../../../functions/functions";
import ModalCuotas from "./ModalCuotas";
import ModalEditCuotas from "./ModalEditCuotas";
import DateFilter from "../../../components/ParadigmaTable/DateFilter";
import NumericFilter from "../../../components/ParadigmaTable/NumericFilter";

class TableCuotas extends Component {
    constructor(props) {
        super(props);
        this.state = {
            outerSort: [
                {
                    id: 'esEntrega',
                    desc: true
                },
                {
                    id: "vencimiento",
                    desc: false,
                },
            ],
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Moneda",
                    id: "moneda",
                    filterable: false,
                    show: false,
                    private: true,
                },
                {
                    Header: "cantidadCuotas",
                    id: "cantCuotas",
                    accessor: (d) => d.nroCuota,
                    className: "text-center",
                    show: false,
                    private: true,
                },
                {
                    Header: "Nro.",
                    id: "nroCuota",
                    accessor: (d) =>
                        d.esEspecial
                            ? "E " + (parseInt(d.nroCuota) + parseInt(d.cantCuotas))
                            : d.nroCuota,
                    className: "text-center",
                    show: false,
                    private: true,
                    width: 50,
                },
                {
                    Header: "Nro.",
                    id: "nroCuotaAux",
                    accessor: (d) =>
                        d.esEspecial ? "E " + d.nroCuotaAux : d.nroCuotaAux,
                    className: "text-center",
                    show: true,
                    width: 50,
                },
                {
                    Header: "Estado",
                    id: "estado",
                    accessor: (d) => {
                        switch (d.estado) {
                            case "IMPAGA":
                                return (
                                    <div className="ui-status-pill is-warning">
                                        IMPAGA
                                    </div>
                                );
                            case "PAGA":
                                return (
                                    <div className="ui-status-pill is-success">
                                        PAGA
                                    </div>
                                );
                            case "VENCIDA":
                                return (
                                    <div className="ui-status-pill is-danger">
                                        VENCIDA
                                    </div>
                                );
                        }
                    },
                    lookup: "exact",
                    Filter: ({ filter, onChange }) => (
                        <select
                            value={filter ? filter.value : ""}
                            onChange={(e) => onChange(e.target.value)}
                        >
                            <option value="">Todos</option>
                            <option value="IMPAGA">Impaga</option>
                            <option value="PAGA">Paga</option>
                            <option value="VENCIDA">Vencida</option>
                        </select>
                    ),
                    show: true,
                },
                {
                    Header: "Vencimiento",
                    id: "vencimiento",
                    className: "text-center",
                    accessor: (d) => moment(d.vencimiento).format("DD/MM/YYYY"),
                    Filter: ({ filter, onChange }) => (
                        <DateFilter filter={filter} onChange={onChange} />
                    ),
                    show: true,
                },
                {
                    Header: "Monto",
                    id: "monto",
                    className: "text-right",
                    accessor: d => `${d.moneda.simbolo} ${format(d.monto)}`,
                    show: true,
                    Filter: ({ filter, onChange }) => (
                        <NumericFilter filter={filter} onChange={onChange} />
                    ),
                },
                {
                    Header: "Interés",
                    id: "interes",
                    accessor: d => `${d.moneda.simbolo} ${format(d.interes)}`,
                    className: "text-right",
                    show: true,
                    filterable: false,
                },
                {
                    Header: "Total",
                    id: "montoActualizado",
                    accessor: d => `${d.moneda.simbolo} ${format(d.montoActualizado)}`,
                    className: "monto",
                    show: true,
                    Filter: ({ filter, onChange }) => (
                        <NumericFilter filter={filter} onChange={onChange} />
                    ),
                },
                {
                    Header: "Fecha de pago",
                    id: "fechaPago",
                    accessor: (d) =>
                        d.fechaPago
                            ? moment(d.fechaPago).format("DD/MM/YYYY")
                            : "-",
                    className: "text-center",
                    show: true,
                    Filter: ({ filter, onChange }) => (
                        <DateFilter filter={filter} onChange={onChange} />
                    ),
                },
                {
                    Header: "Pago",
                    id: "pago",
                    accessor: d => `${d.moneda.simbolo} ${format(d.pago)}`,
                    show: true,
                    className: "monto",
                    Filter: ({ filter, onChange }) => (
                        <NumericFilter filter={filter} onChange={onChange} />
                    ),
                },
                {
                    Header: "Tipo",
                    id: "tipoCuotaAux",
                    accessor: (d) => (
                        <div className="text-center">{d.tipoCuotaAux}</div>
                    ),
                    show: true,
                    lookup: "exact",
                    Filter: ({ filter, onChange }) => (
                        <select
                            value={filter ? filter.value : ""}
                            onChange={(e) => onChange(e.target.value)}
                        >
                            <option value="">Todos</option>
                            <option value="Comun">Comun</option>
                            <option value="Especial">Especial</option>
                            <option value="Entrega">Entrega</option>
                        </select>
                    ),
                },
                {
                    Header: "Recibo",
                    id: "nroRecibo",
                    accessor: (d) =>
                        d.nroRecibo && (
                            <a
                                href={
                                    api.servicios.recibo.replace(
                                        "$id_loteo",
                                        this.props.id()
                                    ) +
                                    d.id +
                                    "/"
                                }
                                target="_blank"
                            >
                                Recibo Nro. {d.nroRecibo}
                            </a>
                        ),
                    show: true,
                    className: "text-center",
                    filterable: false,
                },
            ],
        };
    }

    render() {
        let buttons = [
            {
                detail: true,
                component: (props) => (
                    <ModalCuotas
                        {...props}
                        action="DETAIL"
                        idServicio={this.props.id}
                    />
                ),
                permission: "servicios_servicios_detail",
            },
        ];

        if (!this.props.disabled && this.props.disabledCobro) {
            buttons.push({
                edit: true,
                component: (props) => (
                    <ModalCuotas
                        {...props}
                        action="PAGAR"
                        idServicio={this.props.id}
                    />
                ),
                permission: "servicios_servicios_edit",
            });

            buttons.push({
                edit: true,
                component: (props) => (
                    <ModalCuotas
                        {...props}
                        action="NOPAGA"
                        idServicio={this.props.id}
                    />
                ),
                permission: "servicios_servicios_edit",
            });
        }

        buttons.push({
            edit: true,
            component: (props) => (
                <ModalEditCuotas
                    {...props}
                    action="EDIT"
                    idServicio={this.props.id}
                />
            ),
            permission: "servicios_servicios_edit",
        });
        return (
            <ParadigmaTable
                buttons={buttons}
                defaultPageSize={13}
                depth={1}
                apiUrl={api.servicios.cuotas.replace("$id", this.props.id())}
                columns={this.state.columns}
                exportUrl={api.servicios.cuotas}
                title={"Cuotas"}
                outerSort={this.state.outerSort}
            />
        );
    }
}

export default TableCuotas;



// WEBPACK FOOTER //
// ./src/views/Servicios/Servicios/TableCuotas.js